<template>
  <div>
    <van-tabbar :value="active" safe-area-inset-bottom @change="push" :z-index="99" :active-color="color">
      <van-tabbar-item v-for="(item, i) in items" :key="i">
        <div slot="icon" class="icon">
          <img v-if="active===i" :src="item.active" alt="">
          <img v-else :src="item.inactive" alt="">
        </div>
        {{ item.title }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  props: {
    active: {type: Number, default: 0}
    // active: Number,
  },
  data() {
    return {
      color: window.g.main_color,
      items: [
        {
          active: require('../assets/image/foot/shouye_jianji.png'),
          inactive: require('../assets/image/foot/shouye_weidianji.png'),
          title: '首页'
        },
        {
          active: require('../assets/image/foot/yundian_dainji.png'),
          inactive: require('../assets/image/foot/yundian_weidianji.png'),
          title: '云店'
        },
        {
          active: require('../assets/image/foot/icon_menu_task_1.png'),
          inactive: require('../assets/image/foot/icon_menu_task_0.png'),
          title: '去赚钱'
        },
        {
          active: require('../assets/image/foot/huipin_dianji.png'),
          inactive: require('../assets/image/foot/huipin_weidianji.png'),
          title: '惠拼优选'
        },
        {
          active: require('../assets/image/foot/wode_dianji.png'),
          inactive: require('../assets/image/foot/wode.png'),
          title: '我的'
        }
      ]
    }
  },
  watch: {
    // '$route' (val) {
    //   switch (val.path) {
    //     case '/': this.set(0)
    //       break
    //     case '/benefit': this.set(1)
    //       break
    //     case '/college': this.set(2)
    //       break
    //     case '/my': this.set(3)
    //   }
    // }
  },
  created() {
    // this.active = this.$store.state.navInde
    console.log("foot-active=" + this.active)
  },
  updated() {
    // this.active = this.$store.state.navInde
    console.log("foot-active=" + this.active)
  },
  computed: {},
  methods: {
    push(i) {
      this.$store.commit('saveNavIndex', i)
      switch (i) {
        case 0:
          this.$router.replace('/')
          break
        case 1:
          this.$router.replace('/whyd')
          break
        // case 2: location.replace('https://appfktptv3l5652.h5.xiaoeknow.com/homepage?entry=2&entry_type=2001')
        case 2:
          location.replace('task')
          break
        case 3:
          this.$router.replace('/hpyx')
          break
        case 4:
          this.$router.replace('/me')
      }
    }
  }
}
</script>

<style scoped>
.icon img {
  width: 24px; /*no*/
  height: 24px; /*no*/
}

/deep/ .van-tabbar-item__icon {
  margin-bottom: 2px /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue